import script from "./BlockKerja.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockKerja.vue?vue&type=script&setup=true&lang=js"

import "./BlockKerja.vue?vue&type=style&index=0&id=1cfe50d7&lang=css"

const __exports__ = script;

export default __exports__